import { Link } from 'react-router-dom';
import { useProjectContext } from '@/project/ProjectContext';
import styles from './ProjectSwitcher.module.css';

export function ProjectSwitcher() {
  const { projects, projectsLoading, selectedProjectId, setSelectedProjectId } =
    useProjectContext();

  return (
    <div className={styles.wrap}>
      <label className="sr-only" htmlFor="project-switcher">
        Project
      </label>
      <select
        id="project-switcher"
        className={styles.select}
        disabled={projectsLoading}
        value={
          selectedProjectId && projects.some((p) => p.id === selectedProjectId)
            ? selectedProjectId
            : 'all'
        }
        onChange={(e) => {
          const v = e.target.value;
          setSelectedProjectId(v === 'all' ? null : v);
        }}
      >
        <option value="all">Alle projecten</option>
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
      <Link to="/app/projects" className={styles.manageLink}>
        Beheren
      </Link>
    </div>
  );
}

export function ProjectDot({ color }: { color: string | null }) {
  const fill = color ?? 'var(--color-border)';
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden className={styles.dotSvg}>
      <circle cx="5" cy="5" r="5" fill={fill} />
    </svg>
  );
}
